import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { GRID_ACTION } from 'shared/components/Disclaimer/constants';

export const ActionSection = styled(Box)(({ theme }) => ({
  gridArea: GRID_ACTION,
  display: 'flex',
  padding: theme.spacing(2),
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'end',
  },
}));
